<template>
    <div class="entity-name">
        <div class="entity-item" v-for="(item, key) in entityData" :key="key">
            <span class="letf-content">
                <div class="langeages-ch">{{ mapLangeages[key] || "未知语言" }}</div>
                <div class="langeages-en">{{ key }}</div>
            </span>
            <el-input
                :key="key"
                class="entity-input"
                :class="{ 'is-error-input': entityData[key] == '' }"
                v-model="entityData[key]"
                placeholder="输入多个名称，请用中文分号；隔开"
            ></el-input>
            <div class="entity-icon">
                <el-tooltip v-if="key == defaultLang" effect="dark" content="默认语种不可删除" placement="top">
                    <i class="el-icon-question"></i>
                </el-tooltip>
                <i class="el-icon-error" v-else @click="delEntity(key)"></i>
            </div>
        </div>
        <!-- select下拉 -->
        <div class="lange-sele">
            <div class="show-text">设置语种 <i class="el-icon-setting"></i></div>
            <el-select class="opt-sele" v-model="selectLang" multiple collapse-tags placeholder="请选择" @change="changeHandle">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                    <span style="float: left">{{ item.label }}</span>
                    <span v-if="item.value === defaultLang" style="float: right; color: #8492a6; margin-right: 20px;">默认语种</span>
                </el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
import { cloneDeep } from "lodash";
import { businessLangs } from "@/components/langSelect/languages";
import i18n from "@/i18n";

export default {
    name: "EntityList",
    model: {
        prop: "dataList",
        event: "change"
    },
    props: {
        dataList: {
            type: Object,
            default() {
                return {};
            }
        },
        type: {
            type: String
        }
    },
    data() {
        return {
            entityData: {}, // 实体列表
            selectLang: [], // 选中语言
            mapLangeages: {}
        };
    },
    computed: {
        options() {
            const languages = this.$store.state.auth.businessSetting.languages;
            const optionData = languages.map(item => ({
                value: item,
                label: this.mapLangeages[item] || "未知语言",
                disabled: item === this.defaultLang
            }));
            return optionData;
        },
        defaultLang() {
            return this.$store.state.zhiji.gameState.defaultLang;
        }
    },
    watch: {
        entityData: {
            handler(newVal) {
                this.$emit("change", newVal)
            },
            immediate: true,
            deep: true,
        }
    },
    created() {
        // 初始化数据转换
        this.convertEntityData();
        // 所有语言映射
        const res = businessLangs();
        this.mapLangeages = res.reduce((obj, item) => {
            obj[item.lang] = i18n.t(item.i18nKey)
            return obj;
        }, {});
    },
    methods: {
        convertEntityData() {
            const deepCloneData = cloneDeep(this.dataList);
            this.selectLang = [];
            if (this.type === "add") {
                // 新增 把默认语言加进去
                deepCloneData[this.defaultLang] = "";
                this.selectLang.push(this.defaultLang);
            } else {
                //  编辑
                for (const i in deepCloneData) {
                    if (Object.prototype.hasOwnProperty.call(deepCloneData, i)) {
                        this.selectLang.push(i);
                        const strName = deepCloneData[i].map(item => item.entity_name).join("；");
                        deepCloneData[i] = strName;
                    }
                }
            }
            this.entityData = deepCloneData;
        },
        delEntity(lang) {
            this.selectLang = this.selectLang.filter(item => item !== lang);
            delete this.entityData[lang];
        },
        changeHandle(data) {
            if (data.length > Object.keys(this.entityData).length) {
                // 加项
                data.map(item => {
                    if (!this.entityData[item]) {
                        this.$set(this.entityData, item, this.dataList[item] ? this.dataList[item].map(item => item.entity_name).join(";") : "");
                    }
                });
            } else {
                // 减
                for (const key in this.entityData) {
                    if (Object.hasOwnProperty.call(this.entityData, key)) {
                        if (!data.find(item => item === key)) {
                            delete this.entityData[key];
                        }
                    }
                }
            }
        },
    }
};
</script>

<style lang="less" scoped>
.entity-name {
    /deep/.el-input__inner {
        border: 1px solid #dcdfe6;
    }
    .entity-item {
        width: 516px;
        height: 48px;
        border: 1px solid #d8e4f0;
        background: #fafbfd;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: -1px;
        border-radius: 3px;
        .letf-content {
            flex: 2;
            padding-left: 8px;
            .langeages-ch {
                color: #41475e;
            }
            .langeages-en {
                color: #7a7f8f;
            }
        }
        .entity-input {
            flex: 7;
        }
        .entity-icon {
            flex: 1;
            text-align: center;
            font-size: 18px;
        }
    }
    .lange-sele {
        margin-top: 5px;
        position: relative;
        .show-text {
            position: absolute;
            top: 0;
            left: 0;
            width: 100px;
            height: 32px;
            z-index: -1px;
            line-height: 32px;
            color: #2ec2ff;
        }
        .opt-sele {
            width: 150px;
            height: 32px;
            opacity: 0;
            cursor: pointer;
            /deep/.el-icon-close {
                display: none;
            }
        }
    }
}
</style>
